import defaultLayout from '../views/layout/default'

export default {
  path: '/',
  component: defaultLayout,
  children: [
    {
      path: '/',
      name: 'index',
      component: () => import('@/views/index')
    },
    {
      path: '/collections',
      name: 'collections',
      component: () => import('@/views/collections')
    },
    {
      path: '/collections/:id',
      name: 'collectionDetail',
      component: () => import('@/views/collection-detail')
    },
    {
      path: '/shop',
      name: 'shop',
      component: () => import('@/views/shop')
    },
    {
      path: '/project',
      name: 'project',
      component: () => import('@/views/project')
    },
    {
      path: '/project/:id',
      name: 'projectDetail',
      component: () => import('@/views/project-detail')
    },
    {
      path: '/press',
      name: 'press',
      component: () => import('@/views/press')
    },
    {
      path: '/about',
      name: 'about',
      component: () => import('@/views/about')
    }
  ]
}